import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, PawPrint, Lock, Mail } from "lucide-react";
import { login } from "../../lib/adminApi";
import { useAuth } from "../AuthContext";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const { user, refresh, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [erro, setErro] = useState(null);
  const [enviando, setEnviando] = useState(false);

  if (!loading && user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await login(email.trim().toLowerCase(), password);
      await refresh();
      navigate("/admin", { replace: true });
    } catch (err) {
      const status = err?.response?.status;
      let msg = "Credenciais inválidas.";
      if (status === 429) msg = err?.response?.data?.detail || "Demasiadas tentativas.";
      setErro(typeof msg === "string" ? msg : "Credenciais inválidas.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-5 py-12"
      style={{ background: "radial-gradient(1000px 500px at 80% -10%, rgba(30,95,110,0.15), transparent 60%), linear-gradient(180deg, #FAF7F2 0%, #E9EFF0 100%)" }}
      data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-2 mb-8">
          <span className="grid h-11 w-11 place-items-center rounded-xl bg-[#1E5F6E] text-[#FAF7F2] shadow-glow">
            <PawPrint className="h-6 w-6" strokeWidth={2.4} />
          </span>
          <span className="font-display text-2xl font-extrabold">Vet Clinic</span>
        </div>

        <div className="rounded-3xl bg-white border border-[#1E5F6E]/10 p-7 md:p-9 shadow-soft">
          <h1 className="font-display text-2xl md:text-3xl font-bold text-[#1A1A1A]">Entrar no backoffice</h1>
          <p className="text-sm text-[#5A5A5A] mt-1">Acesso reservado à equipa Vet Clinic.</p>

          <form onSubmit={onSubmit} className="mt-7 space-y-4" data-testid="login-form">
            <label className="block">
              <span className="block text-sm font-semibold mb-1.5">Email</span>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#5A5A5A]" />
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="input-email"
                  className="w-full rounded-xl bg-white border-2 border-[#1E5F6E]/10 px-10 py-3 text-sm focus:border-[#1E5F6E] focus:outline-none"
                  autoComplete="username"
                />
              </div>
            </label>
            <label className="block">
              <span className="block text-sm font-semibold mb-1.5">Password</span>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#5A5A5A]" />
                <input
                  type="password"
                  required
                  minLength={8}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  data-testid="input-password"
                  className="w-full rounded-xl bg-white border-2 border-[#1E5F6E]/10 px-10 py-3 text-sm focus:border-[#1E5F6E] focus:outline-none"
                  autoComplete="current-password"
                />
              </div>
            </label>

            {erro && (
              <div className="rounded-xl bg-rose-50 border border-rose-200 text-rose-700 px-4 py-2.5 text-sm" data-testid="login-erro">
                {erro}
              </div>
            )}

            <button
              type="submit"
              disabled={enviando}
              data-testid="btn-login"
              className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#1E5F6E] px-6 py-3.5 text-sm font-bold text-white hover:bg-[#174E5B] disabled:opacity-40 transition-colors"
            >
              {enviando && <Loader2 className="h-4 w-4 animate-spin" />}
              Entrar
            </button>

            <div className="text-center mt-2">
              <span
                title="Será ativado em breve"
                data-testid="forgot-password-disabled"
                className="inline-block text-xs text-[#5A5A5A] cursor-not-allowed opacity-60"
              >
                Esqueci a password
              </span>
            </div>
          </form>
        </div>

        <p className="text-center text-xs text-[#5A5A5A] mt-6">
          Vet Clinic • Backoffice protegido
        </p>
      </div>
    </div>
  );
}
